import React, { FC } from 'react';
import { useQuery } from 'react-query';
import MainLayout from 'components/main-layout/MainLayout';
import API from 'core/Api';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { useTranslation } from 'react-i18next';
import StepTwo from './components/StepTwo';

const Screen: FC = () => {
  const { t } = useTranslation();
  const { client } = useActiveClientContext();

  const { isLoading, error, data } = useQuery(buildClientEntity('step-two', client), () =>
    API.get<[]>('document-wizard/step-two').then(res => res.data)
  );

  return (
    <MainLayout
      title={t('docWizard.title')}
      isLoading={isLoading}
      error={error}
    >
      {data && <StepTwo data={data} />}
    </MainLayout>
  );
};

export default Screen;
